import { CircularProgress as CircularProgressMui } from '@mui/material';

import { useMessages } from '../../hooks/useMessages';

function CircularProgress(props) {
    const { L } = useMessages();

    return <CircularProgressMui title={L.misc_progress_indicator} {...props} />;
}

export default CircularProgress;
